export default {
  init() {
    // accessible bio on mobile
    $('.vignette-artistes label').on('click', function () {
      this.setAttribute('aria-disabled', true);
      const parentNode = $(this).parent();
      $(parentNode).children('.vignette-artistes .bio').attr('aria-expanded', true);
    });
  },
};
